import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { MenuItem, Select, FormControl } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import IconButton from "@mui/material/IconButton";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import AlertMessage from "../../Components/Alert/Alert";
import "./registration.css";

const Registration = () => {
	const navigate = useNavigate();
	const [activeStep, setActiveStep] = useState(0);
	const [inputsValues, setInputsValues] = useState({
		name: "",
		surname: "",
		date: "",
		country: "",
		phone: "",
		email: "",
		password: "",
		passwordRepeat: "",
	});
	const [showPassword, setShowPassword] = useState({
		password: false,
		passwordRepeat: false,
	});
	const [alertParams, setAlertParams] = useState({
		open: false,
		message: "",
		type: "",
	});
	const countries = [
		{ code: "US", label: "United States", phone: "1" },
		{ code: "RU", label: "Russia", phone: "7" },
		{ code: "FR", label: "France", phone: "33" },
		{ code: "DE", label: "Germany", phone: "49" },
		{ code: "CN", label: "China", phone: "86" },
		{ code: "GB", label: "United Kingdom", phone: "44" },
		{ code: "IN", label: "India", phone: "91" },
		{ code: "JP", label: "Japan", phone: "81" },
		{ code: "BR", label: "Brazil", phone: "55" },
		{ code: "AU", label: "Australia", phone: "61" },
		{ code: "CA", label: "Canada", phone: "1" },
		{ code: "IT", label: "Italy", phone: "39" },
		{ code: "ES", label: "Spain", phone: "34" },
		{ code: "MX", label: "Mexico", phone: "52" },
		{ code: "ZA", label: "South Africa", phone: "27" },
		{ code: "KR", label: "South Korea", phone: "82" },
		{ code: "AR", label: "Argentina", phone: "54" },
		{ code: "NL", label: "Netherlands", phone: "31" },
		{ code: "SE", label: "Sweden", phone: "46" },
		{ code: "CH", label: "Switzerland", phone: "41" },
		{ code: "BE", label: "Belgium", phone: "32" },
		{ code: "TR", label: "Turkey", phone: "90" },
		{ code: "PL", label: "Poland", phone: "48" },
		{ code: "ID", label: "Indonesia", phone: "62" },
		{ code: "PH", label: "Philippines", phone: "63" },
		{ code: "TH", label: "Thailand", phone: "66" },
		{ code: "EG", label: "Egypt", phone: "20" },
		{ code: "NG", label: "Nigeria", phone: "234" },
		{ code: "PK", label: "Pakistan", phone: "92" },
		{ code: "MY", label: "Malaysia", phone: "60" },
		{ code: "SG", label: "Singapore", phone: "65" },
		{ code: "SA", label: "Saudi Arabia", phone: "966" },
		{ code: "UA", label: "Ukraine", phone: "380" },
		{ code: "VN", label: "Vietnam", phone: "84" },
		{ code: "AE", label: "United Arab Emirates", phone: "971" },
		{ code: "CO", label: "Colombia", phone: "57" },
		{ code: "BD", label: "Bangladesh", phone: "880" },
		{ code: "IR", label: "Iran", phone: "98" },
		{ code: "KE", label: "Kenya", phone: "254" },
		{ code: "IL", label: "Israel", phone: "972" },
		{ code: "NZ", label: "New Zealand", phone: "64" },
		{ code: "GR", label: "Greece", phone: "30" },
		{ code: "PT", label: "Portugal", phone: "351" },
		{ code: "HU", label: "Hungary", phone: "36" },
		{ code: "CZ", label: "Czech Republic", phone: "420" },
		{ code: "RO", label: "Romania", phone: "40" },
		{ code: "CL", label: "Chile", phone: "56" },
		{ code: "FI", label: "Finland", phone: "358" },
		{ code: "DK", label: "Denmark", phone: "45" },
		{ code: "NO", label: "Norway", phone: "47" },
		{ code: "IE", label: "Ireland", phone: "353" },
	];

	const handleAlertClose = () => {
		setAlertParams({ ...alertParams, open: false });
	};

	const handleInputsChange = (e) => {
		const { name, value } = e.target;
		setInputsValues((prevInputsValues) => ({
			...prevInputsValues,
			[name]: value,
		}));
	};

	const handleTogglePassword = (name) => {
		setShowPassword({
			...showPassword,
			[name]: !showPassword[name],
		});
	};
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleMouseUpPassword = (event) => {
		event.preventDefault();
	};

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};
	const handleBack = () => {
		if (activeStep === 0) return;
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleRegister = async (email, password) => {
		if (
			Object.values(inputsValues).includes("") &&
			inputsValues.password !== inputsValues.passwordRepeat
		)
			return;
		try {
			const userCredential = await createUserWithEmailAndPassword(
				auth,
				email,
				password
			);
			const user = userCredential.user;

			// Записываем данные в Firestore
			await setDoc(doc(db, "users", user.uid), {
				email: user.email,
				phone: inputsValues.phone,
				name: inputsValues.name,
				surname: inputsValues.surname,
				role: "user",
				createdAt: new Date().toISOString(),
				balance: 0,
				deposits: 0,
				profitableTrades: 0,
				unprofitableTrades: 0,
				orders: 0,
				orderDay: 0,
				withdrawals: 0,
				withdrawalDay: 0,
				chartDeposits: 0,
				depositsDay: 0,
				exchanges: 0,
				exchangesDay: 0,
				pnl: 0,
				invested: 0,
				averageInvestment: 0,
			});
			setAlertParams({
				open: true,
				message: "Вы успешно зарегистрировались!",
				type: "success",
			});
			console.log(
				"Пользователь успешно зарегистрирован и данные добавлены в Firestore"
			);
			navigate("/");
		} catch (error) {
			console.error("Ошибка регистрации:", error);
			setAlertParams({
				open: true,
				message: "Ошибка регистрации",
				type: "error",
			});
		}
	};
	return (
		<div className="registration">
			<AlertMessage
				open={alertParams.open}
				message={alertParams.message}
				type={alertParams.type}
				onClose={handleAlertClose}
			/>
			<div className="registration-wrapper">
				<div className="registration-logo">
					<img src="/icons/logo-login.svg" alt="logo" />
				</div>
				<div className="registration-content">
					<div className="registration-content-wrapper">
						<div className="registration-content-header">
							<div className="registration-content-header-item">
								<p className="registration-content-header-title">
									Добро пожаловать в Cscalp
								</p>
								<h1 className="registration-content-header-subtitle">
									Зарегистрироваться
								</h1>
							</div>
							<div className="registration-content-header-item">
								<p className="registration-content-header-subtitle">
									Уже есть аккаунт?
								</p>
								<Button variant="outlined" onClick={() => navigate("/login")}>
									Войти
								</Button>
							</div>
						</div>
						<div className="registration-content-stepper">
							<Stepper activeStep={activeStep} orientation="vertical">
								<Step onClick={handleBack}>
									<StepLabel>Личная информация</StepLabel>
									<StepContent>
										<div className="registration-content-stepper-wrapper">
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">Имя *</p>
												<TextField
													id="name"
													variant="outlined"
													name="name"
													value={inputsValues.name}
													onChange={handleInputsChange}
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
												/>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">Фамилия *</p>
												<TextField
													id="surname"
													variant="outlined"
													name="surname"
													value={inputsValues.surname}
													onChange={handleInputsChange}
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
												/>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">
													Дата рождения *
												</p>
												<TextField
													id="date"
													variant="outlined"
													name="date"
													type="date"
													value={inputsValues.date}
													onChange={handleInputsChange}
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
												/>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">Страна *</p>
												<FormControl
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
												>
													<Select
														labelId="country-select-label"
														id="country-select"
														value={inputsValues.country}
														onChange={handleInputsChange}
														name="country"
													>
														{countries.map((country) => (
															<MenuItem key={country.code} value={country.label}>
																<div style={{ display: "flex", alignItems: "center" }}>
																	<img
																		loading="lazy"
																		width="20"
																		src={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png`}
																		alt=""
																		style={{ marginRight: 8 }}
																	/>
																	{country.label} (+{country.phone})
																</div>
															</MenuItem>
														))}
													</Select>
												</FormControl>
											</div>
											<Button
												onClick={handleNext}
												variant="contained"
												className="registration-content-stepper-button"
												disabled={
													!inputsValues.name ||
													!inputsValues.surname ||
													!inputsValues.date ||
													!inputsValues.country
												}
												sx={{
													"&.Mui-disabled": {
														backgroundColor: "#6f6f80",
													},
												}}
											>
												Далее
											</Button>
										</div>
									</StepContent>
								</Step>
								<Step>
									<StepLabel>Информация об аккаунте</StepLabel>
									<StepContent>
										<div className="registration-content-stepper-wrapper">
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">
													Номер телефона *
												</p>
												<TextField
													id="phone"
													variant="outlined"
													name="phone"
													value={inputsValues.phone}
													onChange={handleInputsChange}
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
													InputProps={{
														startAdornment: (
															<InputAdornment position="start">
																<>
																	{inputsValues.country && (
																		<>
																			<img
																				src={`https://flagcdn.com/w40/${countries
																					.find((country) => country.label === inputsValues.country)
																					?.code.toLowerCase()}.png`}
																				alt=""
																				style={{
																					width: "20px",
																					height: "15px",
																					marginRight: "5px",
																				}}
																			/>
																			<p style={{ color: "#3d404f" }}>
																				+
																				{
																					countries.find(
																						(country) => country.label === inputsValues.country
																					)?.phone
																				}
																			</p>
																		</>
																	)}
																</>
															</InputAdornment>
														),
													}}
												/>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">Email *</p>
												<TextField
													id="email"
													variant="outlined"
													name="email"
													value={inputsValues.email}
													onChange={handleInputsChange}
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
													}}
													size="small"
												/>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">Пароль *</p>
												<FormControl
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
														"& .MuiIconButton-root": {
															color: "#6f6f80",
														},
													}}
													size="small"
													variant="outlined"
												>
													<OutlinedInput
														id="password"
														type={showPassword.password ? "text" : "password"}
														name="password"
														endAdornment={
															<InputAdornment position="end">
																<IconButton
																	aria-label={
																		showPassword.password
																			? "hide the password"
																			: "display the password"
																	}
																	onClick={() => handleTogglePassword("password")}
																	onMouseDown={handleMouseDownPassword}
																	onMouseUp={handleMouseUpPassword}
																	edge="end"
																>
																	{showPassword.password ? (
																		<FontAwesomeIcon icon={faEyeSlash} />
																	) : (
																		<FontAwesomeIcon icon={faEye} />
																	)}
																</IconButton>
															</InputAdornment>
														}
														value={inputsValues.password}
														onChange={(e) => handleInputsChange(e)}
													/>
												</FormControl>
											</div>
											<div className="registration-content-stepper-item">
												<p className="registration-content-stepper-item-title">
													Подтвердите пароль *
												</p>
												<FormControl
													sx={{
														width: 275,
														border: "1px solid #6f6f80",
														borderRadius: "5px",
														"& .MuiInputBase-input": {
															color: "#3d404f",
														},
														"& .MuiIconButton-root": {
															color: "#6f6f80",
														},
													}}
													size="small"
													variant="outlined"
												>
													<OutlinedInput
														id="passwordRepeat"
														type={showPassword.passwordRepeat ? "text" : "password"}
														name="passwordRepeat"
														endAdornment={
															<InputAdornment position="end">
																<IconButton
																	aria-label={
																		showPassword.passwordRepeat
																			? "hide the password"
																			: "display the password"
																	}
																	onClick={() => handleTogglePassword("passwordRepeat")}
																	onMouseDown={handleMouseDownPassword}
																	onMouseUp={handleMouseUpPassword}
																	edge="end"
																>
																	{showPassword.passwordRepeat ? (
																		<FontAwesomeIcon icon={faEyeSlash} />
																	) : (
																		<FontAwesomeIcon icon={faEye} />
																	)}
																</IconButton>
															</InputAdornment>
														}
														value={inputsValues.passwordRepeat}
														onChange={(e) => handleInputsChange(e)}
													/>
												</FormControl>
											</div>
											<Button
												onClick={() =>
													handleRegister(inputsValues.email, inputsValues.password)
												}
												variant="contained"
												className="registration-content-stepper-button"
											>
												Зарегистрироваться
											</Button>
										</div>
									</StepContent>
								</Step>
							</Stepper>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Registration;
